import styled from "styled-components";
import TextLink from "@streeteasy/design-system/deprecated/actions/text-link";
import { PrimaryMedium } from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const SellerBannerContainer = styled.div`
  margin: 0 auto;
  max-width: 1404px;
  padding: ${({ isRecentSearches }) =>
    isRecentSearches ? "0 48px 24px" : "48px 48px 24px"};

  @media screen and (max-width: ${smallScreen}px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const Title = styled(PrimaryMedium)`
  padding-bottom: 16px;

  @media screen and (max-width: ${smallScreen}px) {
    padding-bottom: 24px;
  }
`;

export const Link = styled(TextLink)`
  display: inline-block;
  margin: 10px 0 0;
`;
